<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <form
        class="form-horizontal "
        role="form"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group form-inline d-flex justify-content-center">
              <label
                for="start_date"
                class="control-label mr-3"
              >Start Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="start_date"
                  valueType="format"
                ></date-picker>
              </div>

              <label
                for="end_date"
                class="control-label mr-3"
              >End Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="end_date"
                  valueType="format"
                ></date-picker>
              </div>
              <b-button
                variant="primary"
                @click.prevent="searchData"
                class="gobutton"
              >Go!</b-button>
            </div>
          </div>
        </div>
      </form>

      <div class="col-md-12 mt-3">
        <b-container fluid>
          <!-- User Interface controls -->
          <hr />
          <b-row>
            <b-col
              sm="4"
              md="4"
              class="my-1"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            striped
            hover
            :items="items"
            :fields="fields"
            :tbody-tr-class="rowClass"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :busy="loading"
            v-model="visibleRows"
          >

            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template v-slot:cell(status)="row">
              <span :class="checkStatus(row.item.status)">{{ row.item.status }}</span>
            </template>

            <!--
            <template v-slot:cell(sessioncount)="row">
              {{ row.item.count }} / {{ row.item.session_max }}
            </template>
            -->

            <template v-slot:cell(created_at)="row">
              {{ formatDateDisplayLocal(row.item.created_at) }}
            </template>
            <template v-slot:cell(expiredate)="row">
              {{ (row.item.expiredate!=null)?formatDateDisplayLocal(row.item.expiredate):"-" }}
            </template>

          </b-table>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  formatDateDisplay,
  formatDateTimeDisplay,
  getTimeFromDateFormat
} from "./../js/utils/date.js";;
export default {
  data() {
    return {
      visibleRows: [],
      loading: false,
      items: null,
      start_date: new Date().toISOString().substring(0, 10),
      end_date: new Date().toISOString().substring(0, 10),
      fields: [
        {
          key: "qr_number",
          label: "QR Number",
          sortable:true
        },
        {
          key: "created_at",
          label: "Sale Date",
          sortable: true
        },
        {
          key: "type",
          label: "Type"
        },
         {
          key: "member_phone",
          label: "Phone Number"
        },
        /*{
          key: "sessioncount",
          label: "Session"
        },*/
        {
          key: "expiredate",
          label: "Expire Date",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable:true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      filter: null,
      //filterOn: ["member.cardid", "payment_type", "package"],
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  components: {
    DatePicker
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "VOID") {
        return "table-danger";
      } else if (item.price_total == 0) {
        return "table-primary";
      }
    },
    itemClick(item, index, target) {},
    async searchData() {
      if (this.start_date !== null && this.end_date !== null) {
        this.loading = true;
        await axios
          .post("/api/qrcodes/list", {
            from: this.start_date,
            to: this.end_date
          })
          .then(response => {
            //console.log(response.data);
            this.items = response.data;
            this.totalRows = this.items.length;
            //console.log(response.data);
            this.loading = false;
          });
      }
    },
    checkStatus(value) {
      switch (value) {
        case "ACTIVE":
          return "active";
          break;
        case "FREEZE":
          return "freeze";
          break;
        case "EXPIRE":
          return "expire";
        case "LOCK":
          return "lock";
        default:
          break;
      }
    },
    getFormatDateTimeDisplay(date) {
      return formatDateTimeDisplay(date);
    },
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    },
  }
};
</script>
<style scoped>
.gobutton {
  width: 80px;
  font-weight: bold;
}
table {
  font-size: 0.9em;
}
.voidtxt {
  color: #f00;
  text-decoration: line-through;
}
.active {
  /*font-size: 1.5em;*/
  color: green;
  font-weight: bold;
}
.freeze {
  /*font-size: 1.5em;*/
  color: blue;
  font-weight: bold;
}
.expire {
  /*font-size: 1.5em;*/
  color: red;
  font-weight: bold;
}
</style>
